<template>
    <div>
        <div class="organization-header">
            <h2 class="header-title">{{pageTitle !== '' ? pageTitle : organizationIn.name}}</h2>
            <div class="tools">
                <b-button variant="primary" v-b-modal="'organization-assignment-show-create-folder-modal'"
                          class="btn-new-folder">
                    <i class="fa fw fa-plus"></i>{{$t('organization.new_map')}}
                </b-button>
                <b-button variant="primary" v-b-modal="'organization-assignment-show-create-assignment-modal'"
                          class="btn-new-assignment" :disabled="organizationIn.assignment_folders.length === 0">
                    <i class="fa fw fa-plus"></i>{{$t('organization.new_exercise')}}
                </b-button>
            </div>
        </div>

        <design-2021-organization-assignment-show-create-assignment-component :selected-folder="selectedFolder"
                                                                  @add-assignment="addAssignment">
        </design-2021-organization-assignment-show-create-assignment-component>

        <design-2021-organization-assignment-show-create-folder-component @add-folder="addFolder"
                                                              :organization-folder-id="organizationIn.id">
        </design-2021-organization-assignment-show-create-folder-component>
    </div>
</template>

<script>
    export default {
        name: "design-2021-organization-assignment-show-header-component",
        props: {
            organizationIn: Object,
            selectedFolder: Number,
            pageTitle: {
                type: String,
                default(){
                    return '';
                }
            }
        },
        methods: {
            addAssignment(assignment){
                this.$emit('add-assignment', assignment);
            },

            addFolder(folder){
                this.$emit('add-folder', folder);
            }
        }
    }
</script>

<style scoped lang="scss">
    .organization-header {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .header-title {
        margin-bottom: 15px;
    }

    .tools {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-grow: 1;
    }

    .btn-new-folder,
    .btn-new-assignment {
        flex: 1 0 100%;
    }

    .btn-new-folder {
        margin-bottom: 15px;
    }

    .tools button > i {
        margin-right: 4px;
        font-size: .875rem;
    }

    @media(min-width: 768px){
        .organization-header {
            align-items: baseline;
            flex-direction: row;
        }

        .header-title {
            margin-bottom: 0;
            display: flex;
            flex-basis: calc(100% - 320px);
            align-self: center;
        }

        .tools {
            flex-direction: row;
            justify-content: flex-end;
            flex-grow: unset;
            flex-basis: 305px;
            margin-left: auto;
        }

        .btn-new-folder{
            margin-right: 15px;
            margin-bottom: 0;
        }

        .btn-new-folder,
        .btn-new-assignment {
            flex: 1 0 auto;
            align-self: baseline;
        }

        .tools .btn i {
            margin-right: 8px;
        }

    }

</style>
